// extracted by mini-css-extract-plugin
export default {"centered":"z-versions_centered__nm4uE","title":"z-versions_title__VDZsw","unsaved-warning":"z-versions_unsaved-warning__I+NsI"};